module.exports = __webpack_public_path__ + "img/logo.d1092e37.svg";